























































































import { Prop, Component, Vue } from 'vue-property-decorator'
import { vxm } from '@/store/'
import PackagesTableRow from './PackagesTableRow.vue'
import { Package } from 'dapp-client'

const numeral = require('numeral')

@Component({
  components: {
    PackagesTableRow
  }
})
export default class PackagesTable extends Vue {
  // Props
  @Prop() filteredPkgs!: Package[]
  // Data
  currentPage = 1
  limit = 10
  offset = 0

  get pkgbyPages() {
    return this.filteredPkgs.slice(this.offset, this.offset + this.limit)
  }

  get pages() {
    return Math.ceil(this.filteredPkgs.length / this.limit)
  }

  setPagination(page: 'first' | 'last' | 'next' | 'prev') {
    if (page === 'first') {
      this.offset = 0
      this.currentPage = 1
    } else if (page === 'last') {
      this.offset = this.pages * this.limit - this.limit
      this.currentPage = this.pages
    } else if (page === 'next') {
      this.offset += this.limit
      this.currentPage++
    } else if (page === 'prev') {
      this.offset -= this.limit
      this.currentPage--
    }
  }

  // Lifecycle hooks
  created() {}
  mounted() {}
  updated() {}
  destroyed() {}
}
